import { Form } from "antd";
import { useLocation, useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";
import { ContractsAcceptedCardTypesTable } from "./ContractsAcceptedCardTypesTable";
import { ContractsVirtualAcceptedCardTypesTable } from "./ContractsVirtualAcceptedCardTypesTable";

export const ContractsAcceptedCardTypesTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const location = useLocation();
    let resourceType = "contract-profiles";
    if (location.pathname.includes("/contracts/physical")) {
        resourceType = "contracts";
    } else if (location.pathname.includes("/contracts/virtual")) {
        resourceType = "contracts-virtual";
    }

    const { id } = useParams();

    return (
        <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
                prevValues.contractProfileId !== currentValues.contractProfileId ||
                prevValues.appProfileListId !== currentValues.appProfileListId ||
                prevValues.acquirerId ||
                currentValues.acquirerId
            }
        >
            {({ getFieldValue }) => {
                const contractProfileId = getFieldValue("contractProfileId");
                const appProfileListId = getFieldValue("appProfileListId");
                const siteId = getFieldValue("siteId");
                const centralized = getFieldValue("centralized");
                const acquirerId = getFieldValue("acquirerId");

                if (resourceType === "contracts-virtual") {
                    return id ? (
                        <Form.Item key={`${field.name}FormItem`} name={field.name}>
                            <ContractsVirtualAcceptedCardTypesTable
                                key={field.name}
                                readOnly={readOnly}
                                siteId={siteId}
                                centralized={centralized}
                                id={Number(id)}
                            />
                        </Form.Item>
                    ) : (
                        <CreateTablePlaceholderComponent />
                    );
                }

                return (
                    <Form.Item key={`${field.name}FormItem`} name={field.name}>
                        <ContractsAcceptedCardTypesTable
                            key={field.name}
                            readOnly={readOnly}
                            contractProfileId={contractProfileId}
                            id={Number(id)}
                            appProfileListId={appProfileListId}
                            acquirerId={acquirerId}
                            resourceType={resourceType}
                        />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};
